import { Component, OnInit } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { AppConfigService } from './app-config.service';
import { Global } from './shared/global.constants';
import { Idle } from 'idlejs';
import { AuthService } from './shared/services/auth/auth.service';
import { ReadConfigService } from './shared/services/common/read-config.service';
import { Router } from '@angular/router';
import { OutageNoticeComponent } from './outage-notice/outage-notice.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  config: any = undefined;
  public orgOpened = true;
  singleOrg = true;
  disableOrgChange = false;
  loggedInUser: any = '';
  loggedIn = false;
  selectedOrg: any;
  orgCount = 0;
  currentYear: any;
  appName = '';
  orgName = '';
  orgAbbr = '';
  openLogOut = false;
  timeLeft: any;
  displayTime = '';
  private Claims: any;
  currPerm: any[];
  loadingIcon: boolean;
  logoutTimer: number;
  maxTimeOut: number;
  idle = new Idle()
    .whenNotInteractive();
  outageMethodTimeout: any;
  googleAnalyticsKey: any;

  constructor(
    private router: Router,
    private authService: AuthService,
    private oauthService: OAuthService,
    private appConfig: AppConfigService,
    private readConfigService: ReadConfigService) {
    this.config = this.appConfig.getConfig();
    this.googleAnalyticsKey = this.config !== undefined ? this.config.GA_ID : '';
    this.appendGaTrackingCode();
    this.verifyScheduledOutage();
  }

  // UPLOAD CHANGES START
  ngOnInit(): void {
    this.logoutTimer = this.config ? this.config.LogoutTimer : 15;
    this.maxTimeOut = this.config !== undefined ? this.config.autoLogoutTime : 10;
    this.outageMethodTimeout = this.config !== undefined ? this.config.OutageMethodTimeout : 1000;
    this.idle.within(this.maxTimeOut).do(() => this.logOutConfirm()).start();
    this.orgOpened = true;
    this.appName = Global.ApplicationName;
    this.orgName = Global.OrganizationName;
    this.orgAbbr = Global.OrgAbbr;
    this.currentYear = new Date().getFullYear();
    this.authService.checkorgCount$.subscribe(
      count => {
        this.orgCount = parseInt(count, 0);
      });
    this.authService.checkLoggedIn$.subscribe(
      status => {
        this.loggedIn = status;
      });
    this.authService.checkUser$.subscribe(user => {
      if (user != null) {
        this.loggedIn = true;
      }
    });
  }

  verifyScheduledOutage() {
    setTimeout(() => {
      if (sessionStorage.getItem('outage') === null) {
        this.verifyScheduledOutage();
      } else {
        if (JSON.parse(sessionStorage.getItem('outage'))) {
          this.loadingIcon = true;
          const outageDetails = this.appConfig.getScheduledMaintenance();
          if (outageDetails && outageDetails.maintenanceFlag) {
            this.loggedIn = false;
            this.router.config = [];
            this.router.config.push(
              { path: 'outagenotice', component: OutageNoticeComponent },
              { path: '', redirectTo: '/outagenotice', pathMatch: 'full' },
              { path: '**', redirectTo: '/outagenotice', pathMatch: 'full' }
            );
            this.router.navigate(['/outagenotice']);
          } else {
            this.saCallback();
          }
          this.loadingIcon = false;
        } else {
          this.saCallback();
        }
      }
    }, this.outageMethodTimeout);
  }

  saCallback() {
    const authUrl = this.config !== undefined ? this.config.AuthUrl : '';
    const originUrl = this.config !== undefined ? this.config.OriginUrl : '';
    const authScope = this.config !== undefined ? this.config.AuthScope : '';
    const clientInfo = this.config !== undefined ? this.config.ClientId : '';
    const clientSecret = this.config !== undefined ? this.config.ClientSecret : '';
    const tokenUrl = this.config !== undefined ? this.config.TokenEndPoint : '';
    const authConfig: AuthConfig = {
      issuer: authUrl,
      redirectUri: originUrl,
      tokenEndpoint: tokenUrl,
      responseType: 'code',
      dummyClientSecret: clientSecret,
      clientId: clientInfo,
      scope: authScope
    };

    this.oauthService.configure(authConfig);
    this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    if (!this.oauthService.hasValidAccessToken()) {
      this.oauthService.loadDiscoveryDocument().then(() => {
        this.oauthService.tryLogin({
          disableOAuth2StateCheck: true
        });
      });
    }
  }

  selectedOrganization(args: any) {
    this.selectedOrg = args;
  }

  setActiveClass(link: string) {
    const paths = location.pathname.replace(/\//g, ',').split(',');
    return paths.length > 1 && link === paths[1] ? 'text-red' : 'text-black';
  }

  logOutConfirm(): void {
    if (!this.loggedIn) { return; }
    this.openLogOut = true;
    this.timeLeft = this.logoutTimer;
    this.displayTime = '00:' + this.logoutTimer;
    this.timeOut();
  }

  timeOut(): void {
    if (this.openLogOut) {
      setTimeout(() => {
        this.timeLeft = this.timeLeft - 1;
        const minutes = Math.floor(this.timeLeft / 60);
        const seconds = this.timeLeft - minutes * 60;

        this.displayTime = '0' + minutes + ':' + ('0' + seconds).slice(-2);
        if (this.timeLeft === 0) {
          // Task 1277:If schedule is in edit mode, redirect doesnt work for timeout.
          this.authService.formChanged(true);
          this.logout(false);
        }
        this.timeOut();
      }, 1000);
    }
  }

  logOutClose(): void {
    this.timeLeft = -1;
    this.openLogOut = false;
  }

  logout(isManual: boolean) {
    this.logOutClose();
    this.orgOpened = true;
    this.loggedIn = false;
    sessionStorage.setItem('logout', 'true');
    this.authService.logout(isManual);
    this.authService.redirectLogoutUser();
  }

  private appendGaTrackingCode() {
    try {
      const gaScript = document.createElement('script');
      gaScript.setAttribute('async', 'true');
      gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=` + this.googleAnalyticsKey);

      const gaScript2 = document.createElement('script');
      gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}` +
        `gtag(\'js\', new Date());gtag(\'config\', \'` + this.googleAnalyticsKey + ` \');`;

      document.documentElement.firstChild.appendChild(gaScript);
      document.documentElement.firstChild.appendChild(gaScript2);
    } catch (ex) {
      console.error('Error appending google analytics');
      console.error(ex);
    }
  }
}
